module.exports = "/_next/static/images/marketingAutomationImage-ef19f8e430e70709bc00995ca9732ae9.jpg.webp";